import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { FormGroup, Button, Container, Row, Col, Form, Label, Input } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withCookies } from 'react-cookie';
import queryString from 'query-string';
import { alert } from '../../actions/alerts';
import {
  getCurrentLocale,
  getUser,
} from '../../selectors';
import Link from '../../components/Link/Link';
import styles from './styles.scss';
import AlertBadge from '../../components/Alerts/AlertBadge';
import Announcement from '../../components/Announcement';

const messages = defineMessages({
  toMainPage: {
    id: 'login.mainPageText',
    defaultMessage: 'Go to main page',
    description: 'Go to Main page button',
  },
  accountHiMessage: {
    id: 'layout.accountHiMessage',
    defaultMessage: 'Welcome Back,',
    description: 'ACCOUNT welcome message',
  },
  loginHeader: {
    id: 'login.Header',
    defaultMessage: 'Sign in',
    description: 'The main header on the login page',
  },
  loginSystemUpdate: {
    id: 'login.SystemUpdated',
    defaultMessage: 'The system has been updated. Please login again to continue.',
    description: 'A message indicating the application has updated',
  },
  emailInstructions: {
    id: 'emailLogin.EmailInstructions',
    defaultMessage: 'Please enter the email associated to your account in order to be verified',
    description: 'Instructions for entering email for verification',
  },
  emailLabel: {
    id: 'emailLogin.emailLabel',
    defaultMessage: 'Email Address',
    description: 'Email Address Input Label',
  },
  submitText: {
    id: 'emailLogin.submitText',
    defaultMessage: 'Submit',
    description: 'Submit button text in login form',
  },
});

const Login = ({ title, cookies, user, currentLocale }) => {
  const [systemUpdated, setSystemUpdated] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setSystemUpdated(!!queryString.parse(window.location.search).system);
  }, []);

  const handleEmailLoginSubmit = () => {
    setIsSubmitting(true);
  };

  return (
    <main className={styles.root}>
      { user ?
        <Container>
          <Row>
            <Col xs={12}>
              <FormattedMessage {...messages.accountHiMessage} />
              {` ${user.firstName} ${user.lastName}!`}
            </Col>
            <Col xs={12}>
              <Button to="/" tag={Link}>
                <FormattedMessage {...messages.toMainPage} />
              </Button>
            </Col>
          </Row>
        </Container>
        :
        <FormGroup className={styles.container}>
          <h1 className={`${styles.loginHeader} text-center`}>
            <FormattedMessage {...messages.loginHeader} />
          </h1>
          <Announcement />
          {systemUpdated ? (
            <AlertBadge hideClose>
              <FormattedMessage {...messages.loginSystemUpdate} />
            </AlertBadge>
          ) : null}
          <FormGroup>
            <Form method="post" action='/email-login-otp' onSubmit={handleEmailLoginSubmit}>
              <p><FormattedMessage {...messages.emailInstructions} /></p>
              <FormGroup className={styles.formGroup}>
                <Label for="emailAddress" className={`${styles.label} h5`}>
                  <FormattedMessage {...messages.emailLabel} />
                </Label>
                <Input
                  className={`${styles.input} fs-unmask`}
                  id="emailAddress"
                  type="email"
                  name="emailAddress"
                  required
                />
                <Input
                  className={styles.input}
                  id="locale"
                  type="hidden"
                  name="locale"
                  value={currentLocale}
                />
              </FormGroup>
              <Button type="submit" block className={styles.buttonSubmit} disabled={isSubmitting}>
                <FormattedMessage {...messages.submitText} />
              </Button>
            </Form>
          </FormGroup>
        </FormGroup>
      }
    </main>
  );
};

const mapState = state => ({
  user: getUser(state),
  currentLocale: getCurrentLocale(state),
});

const mapDispatch = dispatch => ({
  actions: bindActionCreators({ alert }, dispatch),
});

export default injectIntl(connect(mapState, mapDispatch)(withCookies((withStyles(styles)(Login)))));
